import { createAction } from '@reduxjs/toolkit'
import { BalanceType, IWalletSummary, TriggerBlanceType, WalletType } from 'config/types/Wallet'

export const setOpvWallet = createAction<WalletType>('wallet/setOpvWallet')
export const setUsdtWallet = createAction<WalletType>('wallet/setUsdtWallet')
export const setWalletBalance = createAction<BalanceType[]>('wallet/setWalletBalance')
export const updateWalletBalance = createAction<TriggerBlanceType>('wallet/updateWalletBalance')
export const setOpvPrice = createAction<any>('wallet/setOpvPrice')
export const setWalletSummary = createAction<IWalletSummary>('wallet/setWalletSummary')
